<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconBackToTop_24"
    viewBox="0 0 24 24"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M2.938 2a.937.937 0 1 0 0 1.875h18.125a.937.937 0 1 0 0-1.875zm3.119 9.55 5.233-5.183a1.05 1.05 0 0 1 1.48 0l5.233 5.183c.41.406.41 1.06 0 1.466s-1.07.406-1.48 0l-3.377-3.345-.052 11.235c0 .58-.412 1.094-.998 1.094s-1.057-.514-1.057-1.094V9.548l-3.502 3.468c-.41.406-1.07.406-1.48 0a1.03 1.03 0 0 1 0-1.466"
        clip-rule="evenodd"
    />
</svg>
